/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CounselorResponse
 */
export interface CounselorResponse {
    /**
     * 
     * @type {string}
     * @memberof CounselorResponse
     */
    counselorId: string;
    /**
     * 
     * @type {string}
     * @memberof CounselorResponse
     */
    userCode: string;
    /**
     * 
     * @type {string}
     * @memberof CounselorResponse
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof CounselorResponse
     */
    lastName: string;
    /**
     * 
     * @type {boolean}
     * @memberof CounselorResponse
     */
    isActive: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CounselorResponse
     */
    roles: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CounselorResponse
     */
    team: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CounselorResponse
     */
    isTeamLeader: boolean;
    /**
     * 
     * @type {string}
     * @memberof CounselorResponse
     */
    mobileNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof CounselorResponse
     */
    phoneExtension: string | null;
    /**
     * 
     * @type {string}
     * @memberof CounselorResponse
     */
    email: string | null;
    /**
     * 
     * @type {string}
     * @memberof CounselorResponse
     */
    fswUserId: string;
    /**
     * 
     * @type {string}
     * @memberof CounselorResponse
     */
    mandantId: string | null;
    /**
     * 
     * @type {number}
     * @memberof CounselorResponse
     */
    weeklyHours: number | null;
    /**
     * 
     * @type {Date}
     * @memberof CounselorResponse
     */
    lastModifiedAtUtc: Date;
    /**
     * 
     * @type {string}
     * @memberof CounselorResponse
     */
    lastModifiedByUserCode: string;
}

/**
 * Check if a given object implements the CounselorResponse interface.
 */
export function instanceOfCounselorResponse(value: object): value is CounselorResponse {
    if (!('counselorId' in value) || value['counselorId'] === undefined) return false;
    if (!('userCode' in value) || value['userCode'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('roles' in value) || value['roles'] === undefined) return false;
    if (!('team' in value) || value['team'] === undefined) return false;
    if (!('isTeamLeader' in value) || value['isTeamLeader'] === undefined) return false;
    if (!('mobileNumber' in value) || value['mobileNumber'] === undefined) return false;
    if (!('phoneExtension' in value) || value['phoneExtension'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('fswUserId' in value) || value['fswUserId'] === undefined) return false;
    if (!('mandantId' in value) || value['mandantId'] === undefined) return false;
    if (!('weeklyHours' in value) || value['weeklyHours'] === undefined) return false;
    if (!('lastModifiedAtUtc' in value) || value['lastModifiedAtUtc'] === undefined) return false;
    if (!('lastModifiedByUserCode' in value) || value['lastModifiedByUserCode'] === undefined) return false;
    return true;
}

export function CounselorResponseFromJSON(json: any): CounselorResponse {
    return CounselorResponseFromJSONTyped(json, false);
}

export function CounselorResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CounselorResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'counselorId': json['counselorId'],
        'userCode': json['userCode'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'isActive': json['isActive'],
        'roles': json['roles'],
        'team': json['team'],
        'isTeamLeader': json['isTeamLeader'],
        'mobileNumber': json['mobileNumber'],
        'phoneExtension': json['phoneExtension'],
        'email': json['email'],
        'fswUserId': json['fswUserId'],
        'mandantId': json['mandantId'],
        'weeklyHours': json['weeklyHours'],
        'lastModifiedAtUtc': (new Date(json['lastModifiedAtUtc'])),
        'lastModifiedByUserCode': json['lastModifiedByUserCode'],
    };
}

export function CounselorResponseToJSON(json: any): CounselorResponse {
    return CounselorResponseToJSONTyped(json, false);
}

export function CounselorResponseToJSONTyped(value?: CounselorResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'counselorId': value['counselorId'],
        'userCode': value['userCode'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'isActive': value['isActive'],
        'roles': value['roles'],
        'team': value['team'],
        'isTeamLeader': value['isTeamLeader'],
        'mobileNumber': value['mobileNumber'],
        'phoneExtension': value['phoneExtension'],
        'email': value['email'],
        'fswUserId': value['fswUserId'],
        'mandantId': value['mandantId'],
        'weeklyHours': value['weeklyHours'],
        'lastModifiedAtUtc': value['lastModifiedAtUtc'].toISOString(),
        'lastModifiedByUserCode': value['lastModifiedByUserCode'],
    };
}

